import type { SelectOption } from '@ps/web-shared-components';
import { DropDown } from '@ps/web-shared-components';
import { Label } from '@ps/web-shared-ui';
import React, { useEffect, useState } from 'react';

import styles from './EventResultFilter.scss';

export interface Stop {
  id: string;
  name: string;
}

export interface Tour {
  name: string;
  stops: Stop[];
}

interface EventFilter {
  tours: Tour[];
  onFilter(id: string, tour?: string, stop?: string): void;
}

const EventResultFilter: React.FC<EventFilter> = ({ tours, onFilter }) => {
  const [tourFilter, setTourFilter] = useState<SelectOption>();
  const [stopFilter, setStopFilter] = useState<SelectOption>();
  const [tourList, setTourList] = useState<SelectOption[]>([]);
  const [stopList, setStopList] = useState<SelectOption[]>([]);

  useEffect(() => {
    const result = (tours
      .find(({ name }) => name === tourFilter?.value)
      ?.stops.map(({ name, id }) => ({
        text: name,
        value: id
      })) || []) as SelectOption[];

    setStopList(result);
    if (!result.find(({ value }) => stopFilter?.value === value)) {
      setStopFilter(result[0]);
    }
  }, [stopFilter?.value, tourFilter?.value, tours]);

  useEffect(() => {
    const result = tours.map(({ name }) => ({
      text: name,
      value: name
    })) as SelectOption[];

    setTourList(result);
    if (!tourFilter) {
      setTourFilter(result[0]);
    }
  }, [tourFilter, tours]);

  useEffect(() => {
    if (stopFilter?.value) {
      const tourName = tourFilter?.text?.toString();
      const stopName = stopFilter?.text?.toString();
      onFilter(stopFilter?.value as string, tourName, stopName);
    }
  }, [onFilter, stopFilter, tourFilter?.text]);

  return (
    <div className={styles.filter}>
      <div>
        <Label id="tour-filter" className={styles.label}>
          Tour
        </Label>
        <DropDown
          options={tourList}
          id="tour-filter"
          value={tourFilter?.value}
          onSelect={(tour) => setTourFilter(tour)}
        />
      </div>
      <div>
        <Label id="stop-filter" className={styles.label}>
          Stop
        </Label>
        <DropDown
          options={stopList}
          id="stop-filter"
          value={stopFilter?.value}
          onSelect={(stop) => setStopFilter(stop)}
        />
      </div>
    </div>
  );
};

export default EventResultFilter;
